/* eslint-disable import/prefer-default-export */
export const SEPARATOR = '|';

export const STR_SEARCH_KEY = {
  // custom database errors
  DB_CUSTOM_ERROR: 'DB Login Custom script',
  OLD_EMAIL_ERROR: 'is already imported as',
  // user exists errors
  USER_EXISTS_ERROR: 'The user already exists',
  // wrong email or password errors
  PASSWORD_ERROR: 'Wrong email or password',
  // special keyword to be replaced later with real links
  LOGIN_LINK: 'login_link',
  SUPPORT_LINK: 'contact_support_link',
  PASSWORD_RESET_LINK: 'password_reset_link',
  REVERIFY_OTP_LINK: 'reverify_otp_link',
  REVERIFY_OTP_LINK_SCREEN_VERIFY: 'reverify_otp_link_screen_verify',
};

export const SUPPORT_LINK_REPLACE_TEXT = `${SEPARATOR}${STR_SEARCH_KEY.SUPPORT_LINK}${SEPARATOR}`;
export const SUPPORT_LINK_URL = 'https://help.fairprice.com.sg/hc/en-us';
export const SUPPORT_LINK_NAME = 'Customer Support';

export const PASSWORD_RESET_LINK_REPLACE_TEXT = `${SEPARATOR}${STR_SEARCH_KEY.PASSWORD_RESET_LINK}${SEPARATOR}`;
export const PASSWORD_RESET_LINK_NAME = 'reset your password';

const REVERIFY_OTP_LINK_REPLACE_TEXT = `${SEPARATOR}${STR_SEARCH_KEY.REVERIFY_OTP_LINK}${SEPARATOR}`;
export const REVERIFY_OTP_LINK_NAME = 'verify again';

const REVERIFY_OTP_LINK_SCREEN_VERIFY_REPLACE_TEXT = `${SEPARATOR}${STR_SEARCH_KEY.REVERIFY_OTP_LINK_SCREEN_VERIFY}${SEPARATOR}`;
export const REVERIFY_OTP_SCREEN_VERIFY_LINK_NAME = 'request for a new code';

export const ERROR_REPLACE_TEXT = {
  OLD_EMAIL_ERROR: `It seems you have changed your email recently. Please sign in with your new email address, or contact ${SUPPORT_LINK_REPLACE_TEXT}.`,
  GENERIC_DB_ERROR: `Sorry, we are not able to sign you in at the moment. Please contact ${SUPPORT_LINK_REPLACE_TEXT}.`,
  PASSWORD_ERROR: 'Looks like either your email address or password were incorrect. Try again?',
  PASSWORD_ERROR_UNIFIED_SSO: `
  Incorrect password. Please try again or ${PASSWORD_RESET_LINK_REPLACE_TEXT}.`,
  EXPIRED_OTP_ERROR: `Your 6-digit code verification has expired. Please ${REVERIFY_OTP_LINK_REPLACE_TEXT}.`,
  EXPIRED_OTP_ERROR_SCREEN_VERIFY: `Your 6-digit code has expired. Please ${REVERIFY_OTP_LINK_SCREEN_VERIFY_REPLACE_TEXT} and try again.`,
};

export const ERROR_MAP = {
  invalid_signup: 'The user your are attempting to sign up is invalid.',

  // If the password used doesn't comply with the password policy for the connection.
  invalid_password: 'The chosen password is too weak.',
  password_dictionary_error: 'The chosen password is too common.',
  password_no_user_info_error:
    'The chosen password is based on user information. Choose strong password.',
  password_strength_error: 'The chosen password does not match strength requirements.',
  // name
  PasswordStrengthError: 'The chosen password does not match strength requirements.',

  // If you cannot sign up for this application. May have to do with the violation of a specific rule.
  // The user you are attempting to sign in with is blocked
  unauthorized: 'Unauthorized login.',
  user_exists: 'The user you are attempting to sign up has already signed up.',
  username_exists: 'The username you are attempting to sign up with is already in use.',
  // Wrong email or password.',
  // When using web-based authentication, the resource server denies access per OAuth2 specifications.
  // Authentication error.
  access_denied: 'Invalid username and/or password.',
  invalid_user_password: 'Invalid username and/or password.',
  mfa_invalid_code: 'Invalid/expired multi-factor authentication (MFA) code.',
  mfa_registration_required:
    'Multi-factor authentication (MFA) is reuied, but the user has not enrolled.',
  mfa_required: 'Please provide multi-factor authentication (MFA) code to authenticate.',
  // This login attempt has been blocked because the password you're using was previously disclosed through a data breach (not in this application)
  // If the password has been leaked and a different one needs to be used.'
  password_leaked:
    'Your security matters to us. As part of our ongoing security measures, you are required to update your login password. Please check your email for more information.',
  // name
  // (reported when password history feature is enabled).
  PasswordHistoryError: 'The password provided for sign up/update has already been used.',

  // Your account has been blocked after multiple consecutive login attempts. We’ve sent you an email with instructions on how to unblock it.
  too_many_attempts: 'The account is blocked due to too many attempts to sign in.',
  // 'Invalid request body. All and only of client_id, credential_type, username, otp, realm are required.',
  invalid_request: 'Invalid request to login.',
  unauthorized_client: 'Cross origin login not allowed.',
  unsupported_credential_type: 'Unknown credential type parameter.',
  blocked_user: 'This user is blocked.',

  // Showing non-technical error in case of invalid parameters, otherwise error is too technical.
  invalid_parameter: 'Error occurred. Please try again.',

  // PWL API errors
  bad_input: 'Something went wrong. Please check your details and try again.',
  bad_json: 'Something went wrong. Please try again.',
  wrong_otp: 'The 6-digit code you’ve entered is incorrect. Please try again.',
  user_not_found: 'Something went wrong. Please try again.',
  conflict_input: 'You already have an account with us. Please log in to continue.',
  too_many_attempts_pwl: 'Too many failed attempts. Please try again later.',
};
